<mat-divider></mat-divider>

<div style="padding: 10px; font-size: 14px; text-align: center">
  {{ 'activation.otp.info-one' | translate}}
  <br>
  {{ 'activation.otp.info-two' | translate}}
  <br>
  {{ 'activation.otp.info-three' | translate}}
</div>

<div>
  <button (click)="generateCode()" [disabled]="disableGenerate" class="nav-button">
      {{ 'activation.otp.generate' | translate }}
  </button>
</div>

<div class="input-row">
  <div class="form-input">
    <form [formGroup]="smsCodeForm">
      <div>
        <mat-label>{{'activation.otp.input-code' | translate}}</mat-label>
      </div>
      
      <mat-form-field>
        <input class="" matInput formControlName="smsCode">
      </mat-form-field>
    </form>
  </div>

  <div class="form-button">
    <button (click)="confirmCode()" [disabled]="smsCodeForm.get('smsCode').value.length < 6" class="nav-button">
      {{ 'activation.otp.confirm' | translate}}
    </button>
  </div>
</div>